import React from 'react';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import TruncateMarkup from 'react-truncate-markup';
import CardCarousel from '../CardCarousel';
import Styles from './ProductCard.module.scss';
import type { ProductCardData } from '../../types/cards';

interface ProductCardProps {
  data: ProductCardData;
  styles?: any;
  trackCardClick?: () => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ data, styles = {}, trackCardClick }) => {
  const { carouselAspectRatio, category, categoryLink, images, link, linkText, title } = data;
  return (
    <Card className={Styles.card} sx={styles} data-testid="product-card">
      <div className={Styles.cardInner}>
        <CardCarousel
          disableImageLoader
          imageAlt={title}
          images={images?.slice(0, 8)}
          itemAspectRatio={carouselAspectRatio}
          link={link}
          openLinkInNewTab
          segmentEvent={trackCardClick}
          isReferrer
        />
        <CardContent className={Styles.cardContent}>
          <div className={Styles.cardHeader}>
            <div>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={categoryLink}
                data-testid="product-card-category"
                onClick={trackCardClick}
                target="_blank"
                referrerPolicy="no-referrer-when-downgrade"
              >
                <Typography className={Styles.cardCategory} variant="footnote">
                  {category}
                </Typography>
              </a>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={link}
                className={Styles.cardTitle}
                data-testid="product-card-title"
                onClick={trackCardClick}
                target="_blank"
                referrerPolicy="no-referrer-when-downgrade"
              >
                <TruncateMarkup lines={2}>
                  <Typography variant="title3">{title}</Typography>
                </TruncateMarkup>
              </a>
            </div>
          </div>
          {linkText && link && (
            <CardActions className={Styles.cardActions}>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={link}
                data-testid="product-card-link"
                target="_blank"
                referrerPolicy="no-referrer-when-downgrade"
              >
                <Button
                  size="medium"
                  style={{ textDecoration: 'none' }}
                  variant="primary"
                  onClick={trackCardClick}
                >
                  {linkText}
                </Button>
              </a>
            </CardActions>
          )}
        </CardContent>
      </div>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, react/jsx-no-target-blank */}
      <a
        className={Styles.cardLink}
        aria-label={`View ${title}`}
        href={link}
        onClick={trackCardClick}
        target="_blank"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Card>
  );
};

export default ProductCard;
